import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetContentSlice = createSlice({
    name: "getContentRequest",
    initialState,
    reducers: {
        getContentRequest(state) {
            state.loading = true;
        },
        getContentRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getContentRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getContentRequest,
    getContentRequestSuccess,
    getContentRequestError,
} = GetContentSlice.actions;

export default GetContentSlice.reducer;
